// src/screens/NotFound/NotFoundPage.js
import React from 'react';
import IndexFooter from '../Index/Components/IndexFooter';

function NotFoundPage() {
  return (
    <>
    

    <div className="not-found-container bg-warning pt-5">
      <div className="card px-5 py-4 mt-5">
        <h1>404</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
        <a href="/">Go to Home</a>
        </div>
    </div>
   
    <IndexFooter/>
    </>
  );
}

export default NotFoundPage;
